// extracted by mini-css-extract-plugin
export default {"Card":"acceptingNewPatientsCard_Card__Ud3fc","Accepting":"acceptingNewPatientsCard_Accepting__+dTtG","NotAccepting":"acceptingNewPatientsCard_NotAccepting__48SJn"};